import React from 'react';
import { Routes, Route } from 'react-router-dom';

import App from './App';
import MoodHappy from './MoodHappy';
// import MoodSad from './MoodSad';
// import MoodAngry from './MoodAngry';
// import other mood components as needed

export default function MainRouter() {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/happy" element={<MoodHappy />} />
      {/* Add other mood routes here */}
      {/* <Route path="/sad" element={<MoodSad />} /> */}
      {/* <Route path="/angry" element={<MoodAngry />} /> */}
    </Routes>
  );
}
